import * as z from "zod";
import { mutator } from "./mutator";

// Deleting an OAuth app cascades to its grants and per-SA authorizations
// (onDelete: cascade), so every credential it holds stops working immediately.
// This is the tenant-level kill switch for a compromised or retired client.
export const deleteOAuthApp = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    app: { kind: "oauthClient", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:oauth_apps_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { app } }) => {
    await tx.mutate.oauthClient.delete({ id: app.id });
  },
});
